import { FC } from 'react';
import { theme } from 'antd';
import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CompAirAssurePlanIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 94, height = 32, ...rest }) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };

  const primaryColor = token.CompairAssure.colorPrimary;
  const secondaryColor = token.CompairAssure.colorSecondary;

  return (
    <svg width={width} height={height} viewBox="0 0 94 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M63.3323 15.5881H64.1641C65.5005 15.5881 66.2133 14.9643 66.2133 13.8654C66.2133 12.7516 65.5302 12.1131 64.2826 12.1131H63.3323V15.5881ZM64.3569 10.6577C67.0003 10.6577 68.2924 11.6675 68.2924 13.8654C68.2924 15.8406 66.9261 17.0432 64.4311 17.0432H63.3323V20.9637H61.2979V10.6577H64.3569Z"
        fill="#00A650"
      />
      <path d="M70.8501 10.6577V19.3896H74.9784V20.9637H68.816V10.6577H70.8501Z" fill="#00A650" />
      <path
        d="M77.8147 17.0137H81.2006L79.5373 12.3803L77.8147 17.0137ZM80.7999 10.6577L84.7797 20.9637H82.5965L81.7352 18.5283H77.2504L76.3593 20.9637H74.3399L78.3492 10.6577H80.7999Z"
        fill="#00A650"
      />
      <path
        d="M87.2631 10.6577L91.0499 17.8602C91.2282 18.2165 91.4659 18.8403 91.7329 19.7314C91.5549 18.6768 91.4804 17.8897 91.4804 17.3699V10.6577H93.322V20.9637H90.8124L86.9066 13.5982C86.7136 13.2416 86.5058 12.6479 86.298 11.816C86.4761 13.1524 86.5503 13.9695 86.5503 14.2812V20.9637H84.7089V10.6577H87.2631Z"
        fill="#00A650"
      />
      <path
        d="M24.2048 23.2442C21.9876 26.8148 18.8315 29.606 14.5862 31.7543L14.1007 32L13.6148 31.7556C9.10171 29.4868 5.81643 26.4575 3.57122 22.4948C0.834195 17.6641 -0.310409 11.5904 0.0715481 3.92689L0.112487 3.10601L14.0962 0L28.078 3.1055L28.1208 3.9246C28.197 5.39216 28.2174 6.80225 28.181 8.15512C28.1726 8.15512 26.037 8.15487 26.0162 8.15487C26.0485 7.10588 26.0459 6.00604 26.0032 4.85432L14.0962 2.20935L2.19113 4.85381C1.6299 20.8724 8.54836 26.6701 14.0977 29.5791C16.5888 28.2651 19.3568 26.367 21.5987 23.244L24.2048 23.2442Z"
        fill="#0E88D3"
      />
      <path
        d="M14.0969 4.00345L3.83138 6.28375C3.6404 10.1176 3.9626 13.3156 4.66624 16C6.28816 22.1861 9.94727 25.6263 14.0992 27.7135V4.00396L14.0969 4.00345Z"
        fill={primaryColor}
      />
      <path
        d="M27.276 12.935C26.3824 12.4678 25.4888 12.2242 24.6155 12.2242C23.6405 12.2242 23.1327 12.5693 23.1327 13.1582C23.1327 13.9097 23.8844 14.1739 25.0216 14.6818C26.9512 15.5347 27.926 16.3065 27.926 17.8702C27.926 19.7794 26.3216 21.0588 23.5594 21.0588C22.8179 21.0588 22.2966 20.9574 21.685 20.7351L20.8893 18.6717C21.8843 19.1592 22.5437 19.2312 23.5391 19.2312C24.6155 19.2312 25.1841 18.8451 25.1841 18.2358C25.1841 17.4638 24.392 17.0783 23.0923 16.4283C21.4472 15.6158 20.4926 14.9254 20.4926 13.4631C20.4926 11.7367 22.0565 10.3963 24.6562 10.3963C25.5495 10.3963 26.5042 10.6806 27.4792 10.9853L27.276 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M34.4729 12.935C33.5793 12.4678 32.6857 12.2242 31.8122 12.2242C30.8374 12.2242 30.3298 12.5693 30.3298 13.1582C30.3298 13.9097 31.081 14.1739 32.2185 14.6818C34.1479 15.5347 35.1229 16.3065 35.1229 17.8702C35.1229 19.7794 33.5182 21.0588 30.7563 21.0588C29.6188 21.0588 28.5223 20.876 27.5674 20.5309L27.7098 18.4998C28.7049 18.9873 29.7409 19.2312 30.7357 19.2312C31.8122 19.2312 32.381 18.8451 32.381 18.2358C32.381 17.4638 31.5889 17.0783 30.2892 16.4283C28.6438 15.6158 27.6895 14.9254 27.6895 13.4631C27.6895 11.7367 29.2534 10.3963 31.8528 10.3963C32.7467 10.3963 33.7011 10.6806 34.6761 10.9853L34.4729 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M37.9507 10.6603V16.1236C37.9507 18.0126 38.5803 18.9059 39.9815 18.9059C41.5254 18.9059 42.3986 17.667 42.3986 15.2504V10.6603H45.0594V20.9573H42.6423V18.9873C41.8705 20.3885 40.6112 21.1196 38.9865 21.1196C36.5899 21.1196 35.2902 19.6169 35.2902 16.6922V10.6603H37.9507Z"
        fill={primaryColor}
      />
      <path
        d="M51.9565 12.8943C51.6513 12.7928 51.3469 12.7521 51.0423 12.7521C49.3161 12.7521 48.3615 13.9097 48.3615 16.1439V20.9573H45.7211V10.6602H48.0975V12.7117C48.7475 11.1882 49.7629 10.4166 51.1438 10.4166C51.4077 10.4166 51.7126 10.4571 52.0577 10.5181L51.9565 12.8943Z"
        fill={primaryColor}
      />
      <path
        d="M56.0456 12.1225C54.705 12.1225 53.7503 13.1178 53.5474 14.8847H58.4012C58.2593 13.1178 57.3657 12.1225 56.0456 12.1225ZM60.798 16.5297H53.5474C53.6895 18.2562 54.9488 19.3326 56.9189 19.3326C57.9753 19.3326 58.9907 19.0887 59.9451 18.5812V20.612C58.9907 20.998 57.8328 21.2213 56.4515 21.2213C53.0192 21.2213 50.9683 19.1294 50.9683 15.6361C50.9683 12.5085 53.0396 10.3963 56.066 10.3963C59.0512 10.3963 60.798 12.346 60.798 15.6971V16.5297Z"
        fill={primaryColor}
      />
      <path
        d="M11.7388 15.555H16.3693L14.0946 9.21836L11.7388 15.555ZM15.821 6.86253L21.2641 20.9573H18.2786L17.1004 17.6265H10.967L9.74836 20.9573H6.98618L12.4699 6.86253H15.821Z"
        fill={primaryColor}
      />
      <path
        d="M11.7365 15.555H14.0901L14.0924 9.21836L11.7365 15.555ZM14.0901 17.6265H10.9647L9.74613 20.9573H6.98419L12.4676 6.86253H14.0901"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default CompAirAssurePlanIcon;
